module.exports = __webpack_public_path__ + "static/media/gallery-4.b70fcf93.png";